import FormBox from "./FormBox";
import Icon from "@lib/common/components/Icon/Icon";
import { Button, Checkbox, Group, Stack } from "@mantine/core";
import { useState } from "react";

export default function MultiSelectOptions({
  options,
  onSend
}: {
  options: { label: string }[];
  onSend: (v: string) => void;
}) {
  const [selected, setSelected] = useState<string[]>([]);
  const [submitted, setSubmitted] = useState(false);

  const toggleOption = (label: string) => {
    setSelected(prev => (prev.includes(label) ? prev.filter(l => l !== label) : [...prev, label]));
  };

  const handleSubmit = () => {
    if (selected.length > 0) {
      setSubmitted(true);
      onSend(selected.join(", "));
    }
  };

  if (submitted) {
    return null;
  }

  return (
    <FormBox>
      <Stack gap="lg">
        <Stack gap="xs" p="xs">
          {options.map(({ label }) => (
            <Checkbox key={label} label={label} onClick={() => toggleOption(label)} variant="outline" fw={500} />
          ))}
        </Stack>
        <Group>
          <Button
            size="sm"
            disabled={selected.length === 0}
            onClick={handleSubmit}
            leftSection={<Icon name="check" size="0.7rem" variant="solid" />}
            variant="light"
          >
            Confirm
          </Button>
        </Group>
      </Stack>
    </FormBox>
  );
}
